module.exports = __webpack_public_path__ + "static/media/notification-count.7955fc8b.svg";